import { initReveal } from "./src/utils/initReveal";

// Run on initial client-side render
export const onInitialClientRender = () => {
  initReveal();
};

// Re-run after every client-side route change so newly-mounted pages get observed.
// Defer one tick so React has finished committing the new DOM.
export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    window.requestAnimationFrame(() => initReveal());
  }
};
